import { render } from "./Problems.vue?vue&type=template&id=444c1f7b"
import script from "./Problems.ts?vue&type=script&lang=js&external"
export * from "./Problems.ts?vue&type=script&lang=js&external"

import "./Problems.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__